import { jsx as _jsx } from "react/jsx-runtime";
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../../../reducers';
import { highestPossiblePriceSelector } from '../../../selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from '../../../selectors/ProductConfigsSelectors';
import { crmSuiteOwnershipLevel } from '../../../selectors/ProductInventorySelectors';
import ProductLevelSelectionButton from '../HubPlanPickerList/ProductLevelSelectionButton';

const SuiteProductLevelSelectionButtonContainer = ({
  productLevel,
  onClick,
  selected
}) => {
  const crmSuitePrice = useAppSelector(state => {
    const crmSuiteProductConfigurations = suiteProductConfigurationsSelector(state, {
      productLevel
    });
    const highestPriceObject = highestPossiblePriceSelector(state, {
      productConfigurations: crmSuiteProductConfigurations
    });
    return highestPriceObject.monthly.calculatedPrice;
  });
  const ownedSuiteLevel = useAppSelector(state => crmSuiteOwnershipLevel(state));
  const isCurrentPlan = ownedSuiteLevel === productLevel;
  const disabledProductLevel = !ownedSuiteLevel || ownedSuiteLevel === currentOrderedPaidProductLevels[0] ? null : currentOrderedPaidProductLevels[currentOrderedPaidProductLevels.indexOf(ownedSuiteLevel) - 1];
  return /*#__PURE__*/_jsx(ProductLevelSelectionButton, {
    id: `suite-calculator-${productLevel}-button`,
    productLevel: productLevel,
    price: crmSuitePrice,
    onClick: onClick,
    selected: selected,
    isCurrentPlan: isCurrentPlan,
    disabled: currentOrderedPaidProductLevels.indexOf(disabledProductLevel) >= currentOrderedPaidProductLevels.indexOf(productLevel)
  });
};

const SuiteProductLevelPicker = ({
  setProductLevel,
  selectedProductLevel
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "flex-row",
    children: Object.keys(CRM_SUITE_PRODUCTS).map(productLevel => /*#__PURE__*/_jsx(SuiteProductLevelSelectionButtonContainer, {
      productLevel: productLevel,
      onClick: () => setProductLevel(productLevel),
      selected: selectedProductLevel === productLevel
    }, productLevel))
  });
};

export default SuiteProductLevelPicker;